"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GPUDevice_1 = require("engine/rendering/GPUDevice");
var bigwig_reader_1 = require("bigwig-reader");
var TileLoader_1 = require("../TileLoader");
var __1 = require("../..");
var SignalTileLoader = /** @class */ (function (_super) {
    __extends(SignalTileLoader, _super);
    function SignalTileLoader(dataSource, model, contig) {
        var _this = _super.call(this, 2048, 32) || this;
        _this.dataSource = dataSource;
        _this.model = model;
        _this.contig = contig;
        _this.ready = false;
        _this.nChannels = 4;
        _this.initializationPromise().then(function () {
            _this.ready = true;
            _this.onReady();
        });
        return _this;
    }
    SignalTileLoader.cacheKey = function (model) {
        return model.path;
    };
    SignalTileLoader.getAvailableContigs = function (model) {
        var contigs = new Array();
        if (model.path != null) {
            return __1.UCSCBig.getBigLoader(model.path).then(function (b) { return __1.UCSCBig.getContigs(b.header); });
        }
        return Promise.resolve(contigs);
    };
    SignalTileLoader.prototype.mapLodLevel = function (l) {
        if (this.ready) {
            if (l >= this.bigWigLoader.lodMap.length) {
                // l is out of range of lookup table, return the top lod
                return this.bigWigLoader.lodMap[this.bigWigLoader.lodMap.length - 1];
            }
            return this.bigWigLoader.lodMap[l];
        }
        else {
            return l;
        }
    };
    /**
    * Executes callback on every tile value within the range x0 to x1 at a given lod (if the tile has loaded).
    * Successively higher lods are used to fill in missing gaps for tiles that have not yet loaded.
    * If there are no loaded tiles in this range the callback will not fire
    */
    SignalTileLoader.prototype.forEachValue = function (x0, x1, lodLevel, coverGapsWithHigherLevels, callback) {
        var _this = this;
        var lodDensity = Math.pow(2, lodLevel);
        var lodX0 = Math.floor(x0 / lodDensity);
        var lodX1 = Math.ceil(x1 / lodDensity);
        this.forEachTileAtLod(x0, x1, lodLevel, false, function (tile) {
            if (tile.state === TileLoader_1.TileState.Complete) {
                var i0 = Math.max(lodX0 - tile.lodX, 0);
                var i1 = Math.min(lodX1 - tile.lodX, tile.lodSpan - 1);
                for (var i = i0; i <= i1; i++) {
                    var x = tile.x + i;
                    var r = tile.payload.array[_this.nChannels * i + 0];
                    var g = tile.payload.array[_this.nChannels * i + 1];
                    var b = tile.payload.array[_this.nChannels * i + 2];
                    var a = tile.payload.array[_this.nChannels * i + 3];
                    callback(x, r, g, b, a, lodLevel);
                }
            }
            else if (coverGapsWithHigherLevels) {
                // we have a gap here, try the next lod
                // find next lod, accounting for lod aliasing by mapLodLevel
                var nextLodLevel = -1;
                for (var l = lodLevel + 1; l <= _this.topTouchedLod(); l++) {
                    var mappedLod = _this.mapLodLevel(l);
                    if (mappedLod > lodLevel) {
                        nextLodLevel = mappedLod;
                        break;
                    }
                }
                if (nextLodLevel != -1) {
                    _this.forEachValue(Math.max(tile.x, x0), Math.min(tile.x + tile.span, x1), nextLodLevel, coverGapsWithHigherLevels, callback);
                }
                else {
                    // exhausted all lods and found no data that covers the range of this tile
                }
            }
        });
    };
    SignalTileLoader.prototype.initializationPromise = function () {
        var _this = this;
        if (this._initializationPromise == null) {
            this._initializationPromise = this.getBigWigLoader(this.model.path).then(function (loader) {
                _this.bigWigLoader = loader;
                /*
                // determine scale factor
                let maxLod = loader.lodMap[loader.lodMap.length - 1];
                let maxZoomIndex = loader.lodZoomIndexMap[maxLod];

                loader.reader.readZoomData(
                    this.contig,
                    0,
                    this.contig,
                    loader.header.chromTree.chromSize[this.contig],
                    maxZoomIndex,
                ).then(
                (entries) => {
                    // console.log('maxZoom', entries);

                    let maxValue = -Infinity;
                    let maxAvg = -Infinity;
                    for (let entry of entries) {
                        let avg = entry.sumData / entry.validCount;
                        maxAvg = Math.max(avg, maxAvg);
                        maxValue = Math.max(entry.maxVal, entry.maxVal);
                    }

                    let maxValueWeight = 0.0;
                    let maxAverageWeight = 1 - maxValueWeight;

                    let weightedAveraged = maxValue * maxValueWeight + maxAvg * maxAverageWeight;

                    let maxDisparity = maxValue / maxAvg;

                    // this._logarithmicDisplay = maxDisparity > 10;
                    // this._logarithmicDisplay = true;

                    // console.log(maxValue, maxAvg, weightedAveraged);

                    // @! hacky
                    // ideally find some decent mid scale that doesn't necessarily capture all the peaks but makes the overall shape of the data visible
                    // this._dataMultiplier = this._logarithmicDisplay ? (1 / Math.log2(weightedAveraged)) : (1 / (weightedAveraged * 5));
                });
                */
            });
        }
        return this._initializationPromise;
    };
    SignalTileLoader.prototype.onReady = function () {
        var _this = this;
        // preload low-resolution data when we know the size of the contig
        this.dataSource.getContigs().then(function (contigs) {
            var contigInfo = contigs.find(function (c) { return c.id === _this.contig; });
            if (contigInfo != null) {
                var maxX = contigInfo.span - 1;
                var minSpan = 512;
                _this.forEachTile(0, maxX, contigInfo.span / minSpan, true, function () { });
            }
        });
    };
    /**
     * Generate a BigWig loader instance for a given BigWig file path
     */
    SignalTileLoader.prototype.getBigWigLoader = function (path) {
        var _this = this;
        // we use a custom loader so we can explicitly disable caching (which with range requests is bug prone in many browsers)
        var bigWigReader = new bigwig_reader_1.BigWigReader({
            load: function (start, size) {
                return new Promise(function (resolve, reject) {
                    var request = new XMLHttpRequest();
                    // disable caching (because of common browser bugs)
                    request.open('GET', path + '?cacheAvoid=' + SignalTileLoader.requestIndex++, true);
                    request.setRequestHeader('Range', "bytes=" + start + "-" + (size ? start + size - 1 : ""));
                    request.responseType = 'arraybuffer';
                    request.onloadend = function () {
                        if (request.status >= 200 && request.status < 300) {
                            // success-like response
                            resolve(request.response);
                        }
                        else {
                            // error-like response
                            reject("HTTP request error: " + request.statusText + " (" + request.status + ")");
                        }
                    };
                    request.send();
                });
            }
        });
        return bigWigReader.getHeader().then(function (header) {
            var lookupTables = _this.generateLodLookups(header);
            return __assign({}, lookupTables, { header: header, reader: bigWigReader });
        });
    };
    /**
     * Convert a BigWig zoom levels header into maps so we can lookup the zoom level for any given lod
     */
    SignalTileLoader.prototype.generateLodLookups = function (bigWigHeader) {
        var reductionLevelToLod = function (reductionLevel) { return Math.floor(Math.log2(reductionLevel)); };
        var availableLods = bigWigHeader.zoomLevelHeaders.map(function (h) { return reductionLevelToLod(h.reductionLevel); });
        availableLods = availableLods.sort(function (a, b) { return a - b; }); // manual sort method so that javascript doesn't sort our numbers alphabetically X_X
        // lod level 0 should always be available
        if (availableLods[0] !== 0)
            availableLods.unshift(0);
        var highestLod = availableLods[availableLods.length - 1];
        // fill maps
        var lodMap = new Array(highestLod);
        var lodZoomIndexMap = new Array(highestLod);
        var diffLowerLimit = 2;
        var _loop_1 = function (i) {
            // find nearest lod either side of i
            for (var j = 0; j < availableLods.length; j++) {
                var l = availableLods[j];
                if (l > i) { // we've found the upper lod
                    var upperLod = l;
                    var lowerLod = availableLods[j - 1];
                    var diffLower = i - lowerLod;
                    var diffUpper = upperLod - i;
                    // pick closest lod
                    // prevent picking lower-lod if the different is too great – this is to prevent performance issues displaying many tiles
                    var bestLod = ((diffLower < diffUpper) && (diffLower <= diffLowerLimit)) ? lowerLod : upperLod;
                    lodMap[i] = bestLod;
                    break;
                }
            }
            // we failed to find an upper lod therefore use highest lod
            if (lodMap[i] === undefined) {
                lodMap[i] = highestLod;
            }
            // find corresponding index for this lod
            var zoomHeaderEntry = bigWigHeader.zoomLevelHeaders.find(function (h) { return reductionLevelToLod(h.reductionLevel) === lodMap[i]; });
            if (zoomHeaderEntry == null) {
                lodZoomIndexMap[i] = null;
            }
            else {
                lodZoomIndexMap[i] = zoomHeaderEntry.index;
            }
        };
        for (var i = 0; i <= highestLod; i++) {
            _loop_1(i);
        }
        return {
            lodMap: lodMap,
            lodZoomIndexMap: lodZoomIndexMap,
        };
    };
    /**
     * Given a BigWig loader instance, load BigWig data to cover *tile* into texture ArrayBuffer *buffer*.
     * Copies values into *targetChannel* assuming *nChannels* texture channels.
     */
    SignalTileLoader.prototype.getBigWigData = function (bigWigLoader, tile, buffer, nChannels, targetChannel) {
        var zoomIndex = bigWigLoader.lodZoomIndexMap[tile.lodLevel];
        var lodDensity = Math.pow(2, tile.lodLevel);
        // @! use for normalization
        // @! review floor in i0, i1
        var dataPromise;
        if (zoomIndex !== null) {
            // fetch from zoomed
            dataPromise = bigWigLoader.reader.readZoomData(this.contig, tile.x, this.contig, tile.x + tile.span, // @! needs checking,
            zoomIndex).then(function (zoomData) {
                var e_1, _a;
                try {
                    // fill buffer with zoom data regions
                    for (var zoomData_1 = __values(zoomData), zoomData_1_1 = zoomData_1.next(); !zoomData_1_1.done; zoomData_1_1 = zoomData_1.next()) {
                        var entry = zoomData_1_1.value;
                        var x0 = entry.start - tile.x;
                        var x1 = entry.end - tile.x;
                        var i0 = Math.floor(x0 / lodDensity);
                        var i1 = Math.floor(x1 / lodDensity);
                        // fake norm
                        var value = (entry.sumData / entry.validCount);
                        for (var i = i0; i < i1; i++) {
                            buffer[i * nChannels + targetChannel] = value;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (zoomData_1_1 && !zoomData_1_1.done && (_a = zoomData_1.return)) _a.call(zoomData_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return buffer;
            });
        }
        else {
            // fetch 'raw'
            dataPromise = bigWigLoader.reader.readBigWigData(this.contig, tile.x, this.contig, tile.x + tile.span).then(function (rawData) {
                var e_2, _a;
                try {
                    for (var rawData_1 = __values(rawData), rawData_1_1 = rawData_1.next(); !rawData_1_1.done; rawData_1_1 = rawData_1.next()) {
                        var entry = rawData_1_1.value;
                        var x0 = entry.start - tile.x;
                        var x1 = entry.end - tile.x;
                        var i0 = Math.floor(x0);
                        var i1 = Math.floor(x1);
                        var value = entry.value;
                        for (var i = i0; i < i1; i++) {
                            if ((i < 0) || (i >= tile.lodSpan))
                                continue; // out of range
                            buffer[i * nChannels + targetChannel] = value;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (rawData_1_1 && !rawData_1_1.done && (_a = rawData_1.return)) _a.call(rawData_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return buffer;
            });
        }
        return dataPromise;
    };
    SignalTileLoader.prototype.loadPayloadBuffer = function (tile) {
        var buffer = new Float32Array(tile.lodSpan * this.nChannels);
        return this.getBigWigData(this.bigWigLoader, tile, buffer, this.nChannels, 0);
    };
    SignalTileLoader.prototype.getTilePayload = function (tile) {
        var nChannels = this.nChannels;
        // fill float array with zoom data regions
        var tileLoader = this;
        return this.loadPayloadBuffer(tile).then(function (data) {
            return {
                textureUnpackMultiplier: 1,
                array: data,
                sequenceMinMax: {
                    min: 0,
                    max: 0,
                },
                dataUploaded: false,
                getTexture: function (device) {
                    var payload = this;
                    var blockPayload = tileLoader.getBlockPayload(tile);
                    var gpuTexture = blockPayload.getTexture(device);
                    // upload this tile's row to the block if not already uploaded
                    if (!payload.dataUploaded) {
                        var dataWidthPixels = payload.array.length / nChannels;
                        var data_1 = payload.array;
                        // convert float32array to bytes, we lose lots of precision but atleast we see something
                        if (blockPayload.floatPacking) {
                            // use the max value to crush array into the 0-1 range and set payload.unpackMultiplier so we can correct when reading from the texture
                            var max = payload.array.reduce(function (prev, curr, i) { return Math.max(prev, curr); });
                            payload.textureUnpackMultiplier = max;
                            data_1 = new Uint8Array(payload.array.length);
                            for (var i = 0; i < payload.array.length; i++) {
                                data_1[i] = (payload.array[i] / max) * 0xFF;
                            }
                        }
                        gpuTexture.updateTextureData(0, GPUDevice_1.TextureFormat.RGBA, data_1, 0, tile.blockRowIndex, // x, y
                        Math.min(gpuTexture.w, dataWidthPixels), 1);
                        // console.log(`%cupload row: ${tile.blockRowIndex}, key: ${tile.key}`, 'color: green');
                        payload.dataUploaded = true;
                    }
                    return gpuTexture;
                },
                /**
                 * Where 0 corresponds to the first value in the tile and 1, the last
                 * This is design to mirror the behavior of `texture2D` in GLSL
                 */
                getReading: function (u, channel) {
                    var payload = this;
                    var nEntries = tile.lodSpan;
                    var linearFiltering = tile.lodLevel > 0;
                    if (linearFiltering) {
                        var p = Math.max(u * nEntries - 0.5, 0);
                        var low = payload.array[Math.floor(p) * nChannels + channel];
                        var high = payload.array[Math.min(Math.ceil(p), nEntries - 1) * nChannels + channel];
                        var alpha = p - Math.floor(p);
                        return (low * (1 - alpha) + high * alpha);
                    }
                    else {
                        var i = Math.floor(u * nEntries);
                        return payload.array[i * nChannels + channel]; // red channel
                    }
                }
            };
        });
    };
    SignalTileLoader.prototype.createBlockPayload = function (lodLevel, lodX, tileWidth, rows) {
        return {
            _gpuTexture: null,
            floatPacking: false,
            getTexture: function (device) {
                var payload = this;
                // allocate texture if it doesn't already exist
                if (payload._gpuTexture === null) {
                    // console.log(`%ccreate texture ${lodLevel}`, 'color: blue');
                    // use float packing if float textures are not supported
                    var floatSupported = device.capabilities.floatTextures;
                    var linearFilteringSupported = floatSupported ? device.capabilities.floatTexturesLinearFiltering : true;
                    payload.floatPacking = !floatSupported;
                    payload._gpuTexture = device.createTexture({
                        format: GPUDevice_1.TextureFormat.RGBA,
                        // mipmapping should be turned off to avoid rows blending with one another
                        // if TILES_PER_BLOCK = 1 then mipmapping may be enabled
                        generateMipmaps: false,
                        // FireFox emits performance warnings when using texImage2D on uninitialized textures
                        // in our case it's faster to let the browser zero the texture rather than allocating another array buffer
                        mipmapData: null,
                        width: tileWidth,
                        height: rows,
                        dataType: floatSupported ? GPUDevice_1.TextureDataType.FLOAT : GPUDevice_1.TextureDataType.UNSIGNED_BYTE,
                        samplingParameters: {
                            magFilter: (lodLevel > 0 && linearFilteringSupported) ? GPUDevice_1.TextureMagFilter.LINEAR : GPUDevice_1.TextureMagFilter.NEAREST,
                            minFilter: GPUDevice_1.TextureMinFilter.LINEAR,
                            wrapS: GPUDevice_1.TextureWrapMode.CLAMP_TO_EDGE,
                            wrapT: GPUDevice_1.TextureWrapMode.CLAMP_TO_EDGE,
                        },
                        pixelStorage: {
                            packAlignment: 1,
                            unpackAlignment: 1,
                            flipY: false,
                            premultiplyAlpha: false,
                            colorSpaceConversion: GPUDevice_1.ColorSpaceConversion.NONE,
                        },
                    });
                }
                return payload._gpuTexture;
            }
        };
    };
    SignalTileLoader.prototype.releaseBlockPayload = function (payload) {
        if (payload._gpuTexture != null) {
            payload._gpuTexture.delete();
            payload._gpuTexture = null;
        }
    };
    SignalTileLoader.requestIndex = 0;
    return SignalTileLoader;
}(TileLoader_1.TileLoader));
exports.SignalTileLoader = SignalTileLoader;
